import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { TranslationPrefixes } from "consts/translationPrefixes";
import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { getProductDataExtracts } from "../../services/productDataService";
import { ProductDataRow } from "../ProductDataService/types";
import ProductDataResults from "../ProductDataService/ProductDataResults";
import CardComponent from "../shared/CardComponent";

const useStyles = makeStyles((theme) => ({
  empty: { padding: theme.spacing(2), color: theme.palette.text.secondary },
}));

export default function ProductInformationDatabase() {
  const classes = useStyles();
  const { t } = useTranslation();
  const prefix = TranslationPrefixes.productInformationDatabase;

  const [products, setProducts] = useState<ProductDataRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [marketplace, setMarketplace] = useState<string>("USA");

  const loadProducts = useCallback(async () => {
    setLoading(true);
    try {
      const extracts = await getProductDataExtracts();
      const all: ProductDataRow[] = [];
      let mkt = "USA";
      extracts.forEach((ex) => {
        const list = ex.products ?? [];
        list.forEach((p) => all.push(p));
        if (ex.marketplace) mkt = ex.marketplace;
      });
      setProducts(all);
      setMarketplace(mkt);
    } catch (e) {
      toast.error(t("errors.error"));
    } finally {
      setLoading(false);
    }
  }, [t]);

  useEffect(() => {
    loadProducts();
  }, [loadProducts]);

  const currencySymbol = marketplace === "USA" ? "$" : "";

  return (
    <CardComponent title={t(`${prefix}headline`)} isLoading={loading}>
      <Box>
        {products.length === 0 ? (
          <Typography className={classes.empty}>{t(`${prefix}noExtracts`)}</Typography>
        ) : (
          <ProductDataResults
            products={products}
            currencySymbol={currencySymbol}
            maxHeight={560}
          />
        )}
      </Box>
    </CardComponent>
  );
}
